import {environment} from '../../../environments/environment';
import {HttpHeaders} from "@angular/common/http";

export const IDENTITY_TOKEN = environment.identity.host + '/identity/v1/token';

export const PASSWORD_FLOW_DATA = {
  grant_type: 'password',
  scope: environment.identity.scope,
  client_id: environment.identity.clientId
};

export const REFRESH_TOKEN_FLOW_DATA = {
  grant_type: 'refresh_token',
  scope: environment.identity.scope,
  client_id: environment.identity.clientId
};

export const OIDC_DEFAULT_HEADERS =  new HttpHeaders({
  'Content-Type': 'application/x-www-form-urlencoded'
});
